/**
 * Web Vitals Tracker Component
 *
 * Automatically tracks Core Web Vitals for the entire app
 * Mount once at the app root level
 */

import { useWebVitals } from '@/hooks/useWebVitals';

export function WebVitalsTracker() {
  useWebVitals();
  return null; // This component doesn't render anything
}
